import { render, staticRenderFns } from "./sanctionListhistory.vue?vue&type=template&id=a152ee1c&scoped=true"
import script from "./sanctionListhistory.vue?vue&type=script&lang=js"
export * from "./sanctionListhistory.vue?vue&type=script&lang=js"
import style0 from "./sanctionListhistory.vue?vue&type=style&index=0&id=a152ee1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152ee1c",
  null
  
)

export default component.exports